<ng-container *ngIf="dialogWithInput">
    <div mat-dialog-title class="d-flex gap-5">
        <h2 class="flex-grow-1 flex-shrink-1" *ngIf="dialogWithInput.options.title">{{dialogWithInput.options.title}}</h2>
        <div class="flex-grow-0 flex-shrink-0">
            <ng-content select="[header-buttons]"></ng-content>
        </div>
    </div>
  <mat-dialog-content class="orange_theme">
    <div style="height: 100%;">
      <app-permission-restricted-container [permission]="permission" [permissions]="permissions" [showMessageIfNoAccess]="true"
                                           [message]="noPermissionMessage"
                                           [forceNoAccess]="noAccess">
        <ng-content></ng-content>
      </app-permission-restricted-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" style="gap: 5px; display: flex;">
    <app-permission-restricted-container class="flex-grow-1" [permission]="permission" [message]="noPermissionMessage" [permissions]="permissions" [forceNoAccess]="noAccess">
        <div class="d-flex gap-5 flex-grow-1 justify-content-end">
            <ng-content select="[dialog-actions]"></ng-content>
        </div>
    </app-permission-restricted-container>
      <app-button label="Fermer" style="flex-grow: 0;" fill="solid" (clickEvent)="close()" *ngIf="!hideCloseButton" cdkFocusInitial></app-button>
   </mat-dialog-actions>
</ng-container>


